import { eula_en } from './eula_en';

export const locale_en = {
  ...eula_en,
  Organization: 'Organization',
  AreYouSureRemoveMemberFromGroupParam: 'Are you sure to want to remove {0} member from group?',
  AreYouSureRemoveMembersFromGroupParam: 'Are you sure you want to remove {0} members from group?',
  RowsSelected: 'row(s) selected',
  AddToMembers: 'Add to members',
  AssignRolesToGroup: 'Assign roles to group',
  Confirm: 'Confirm',
  Name: 'Name',
  Reset: 'Reset',
  SaveChanges: 'Save Changes',
  GeneralProperties: 'General Properties',
  AddMembersToGroup: 'Add members to group',
  AddMembers: 'Add members',
  UnexpectedError: 'Unexpected Error',
  Confirmation: 'Confirmation',
  DeleteMember: 'Delete Member',
  DeleteMembers: 'Delete Members',
  Cancel: 'Cancel',
  User: 'User',
  Search: 'Search',
  RemoveMember: 'Remove member',
  RemoveMembers: 'Remove members',
  PleaseSelect: 'Pleases select',
  Role: 'Role',
  Scope: 'Scope',
  ScopeType: 'Scope Type',
  RolesAssigned: 'Roles Assigned',
  SearchScope: 'Search Scope',
  GroupParam: 'Group {0}',
  Home: 'Home',
  Groups: 'Groups',
  Members: 'Members',
  Roles: 'Roles',
  AddGroup: 'Add group',
  GroupInfo: 'Group info',
  GroupMembers: 'Group Members',
  CheckGroupInfoAndUsersTabs: 'Please check the group info and members tabs. Something is wrong',
  AddNewGroup: 'Add New Group',
  PleaseEnterName: 'Please enter a name',
  OrganizationDatabaseHasBeenCreated: 'Organization database has been created',
  OK: 'OK',
  SomethingWentWrong: 'Something went wrong',
  OrganizationHasBeenBlocked: 'Organization has been blocked',
  OrganizationHasBeenUnblocked: 'Organization has been unblocked',
  Yes: 'Yes',
  No: 'No',
  DisplayName: 'Display Name',
  Email: 'Email',
  Address: 'Address',
  PleaseEnterAValidEmail: 'Please enter a valid email',
  PleaseEnterAnAddress: 'Please enter an address',
  DefaultLanguage: 'Default Language',
  IsPartner: 'Is Partner',
  IsBlocked: 'Is Blocked',
  PartnerOrganization: 'Partner Organization',
  Unblock: 'Unblock',
  Block: 'Block',
  EnsureDB: 'Ensure DB',
  PleaseCheckTheInfoProvided: 'Please check the info provided. Something is wrong',
  AddMembersToOrganization: 'Add members to organization',
  PleaseSelectOrRemoveRow: 'Please select or remove row',
  Add: 'Add',
  AreYouSureRemoveMemberParam: 'Are you sure want remove {0} member from organization?',
  AreYouSureRemoveMembersParam: 'Are you sure want remove {0} members from organization?',
  DeleteUsers: 'Delete Users',
  InvitationSent: 'Invitation sent',
  InvitationNotSent: 'Invitation not sent',
  ResendInvitation: 'Resend Invitation',
  OrganizationMembers: 'Organization Members',
  Reload: 'Reload',
  TypeOrganizationNameToConfirm: 'Type Organization name to confirm',
  Type: 'Type',
  OrganizationParam: 'Organization {0}',
  Delete: 'Delete',
  CanNotDeleteOrgs: "Can't delete orgs",
  CanNotdeleteOwnOrganization: "Can't delete own Organization",
  AddOrganization: 'Add Organization',
  CheckOrganizationInfoAndUserTabs: 'Please check the organization info and users tabs. Something is wrong',
  AddNewOrganization: 'Add New Organization',
  CreatingOrganizationAndItsDatabase: 'Creating organization and its database. This could take several minutes. Please wait',
  PleaseSelectALanguage: 'Please select a language',
  PleaseSelectOrInvite: 'Please select or invite',
  SelectOrInviteOrganizationMaster: 'Select or Invite Organization Master',
  OrganizationUsers: 'Organization Users',
  SelectRoles: 'Select Roles',
  AddUser: 'Add User',
  PartnerRoles: 'Partner Roles',
  EditPartnerRole: 'Edit Partner Role',
  PleaseSelectASelector: 'Please select a selector',
  RoleName: 'Role Name',
  RolesPermissions: 'Roles permissions',
  Allow: 'Allow',
  Deny: 'Deny',
  Selector: 'Selector',
  Edit: 'Edit',
  CreateRole: 'Create role',
  NewPartnerRole: 'New Partner Role',
  NewRole: 'New Role',
  EditRole: 'Edit Role',
  PleaseSelectAnOrganization: 'Please select an organization',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'This Role is being assigned by default to creators of some types of scopes. Are you sure you want to delete it?',
  RoleDelete: 'Are you sure you want to delete this role?',
  DefaultRoleDelete: 'Are you sure you want to delete this default role?',
  AddToGroups: 'Add to groups',
  AreYouSureWantRemoveUserFromGroup: 'Are you sure you want to remove user from {0} group?',
  AreYouSureWantRemoveUserFromGroups: 'Are you sure you want to remove user from {0} groups?',
  DeleteGroup: 'Delete group',
  DeleteGroups: 'Delete groups',
  RemoveMembership: 'Remove memebership',
  RemoveMemberships: 'Remove memeberships',
  AssignRolesToUser: 'Assign roles to user',
  UserParam: 'User {0}',
  CanNotDeleteOwnUser: "Can't delete own user",
  PasswordMustMatch: 'Password must match',
  AddNewUser: 'Add new user',
  SetPassword: 'Set Password',
  ConfirmPassword: 'Confirm Password',
  BlankPasswordWarning:
    'If you leave the password field blank, the system will assume that this user will use an external authentication provider to login.',
  OrganizationsManagement: 'Organizations Management',
  UsersManagement: 'Users Management',
  RolesManagement: 'Roles Management',
  PartnerRolesManagement: 'Partner Roles Management',
  GroupsManagement: 'Groups Management',
  BackHome: 'Back Home',
  HomeError: 'Sorry, the page you visited does not exist.',
  NotFound: 'Not Found',
  ChangeOrganization: 'Change Organization',
  DeleteUser: 'Delete user',
  ConfirmDeleteUser: 'Are you sure you want to delete user "{0}" with email address "{1}"?',
  UserDeleted: 'User "{0}" with email address "{1}" has been successfully deleted.',

  DisplayingFilteredItems: 'Displaying items filtered by a notification.',
  ShowAllItems: 'Show all items',
  NotificationTimestampMessageMinutes: '{0} minutes ago',
  NotificationTimestampMessageHours: '{0} hours ago',
  Yesterday: 'Yesterday',
  Read: 'Read',
  Unread: 'Unread',
  Action: 'Action',
  AffectedElement: 'Affected element',
  LinkTo: 'Link to',
  State: 'State',
  Date: 'Date',
  Notifications: 'Notifications',
  NotificationStatus: 'Notification status',
  InApp: 'In app',
  NotificationsSettings: 'Notifications settings',
  DeleteAfter: 'Delete after',
  OneWeek: 'One week',
  OneMonth: 'One month',
  OneYear: 'One year',
  ThreeMonths: 'Three months',
  SixMonths: 'Six months',
  DeleteAllNotifications: 'Delete all',
  SurveySynchedRingNotificationDescription: 'The survey "{A}" has been synchronized on drillhole "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'The survey "{A}" has been synchronized on ring "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'The survey "{A}" has been synchronized on the quarantine.',
  OrganizationCreationFinishedNotificationTitle: 'Organization created',
  OrganizationExpirationWarningNotificationTitle: 'Organization about to expire',
  OrganizationCreationErrorNotificationTitle: 'Error creating Organization',
  OrganizationIsAvailableNotificationTitle: 'Organization available',
  LicenseNeedsApprovalNotificationTitle: 'License needs approval',
  LicenseWasRenewedNotificationTitle: 'License was renewed',
  RingCreatedNotificationTitle: 'Ring created',
  SurveySynchedNotificationTitle: 'Survey synchronized',
  ProjectDeletedNotificationTitle: 'Project deleted',
  ProjectEditedNotificationTitle: 'Project edited',
  DrillholeDeletedNotificationTitle: 'Drillhole deleted',
  RingDeletedNotificationTitle: 'Ring deleted',
  DrillholeMovedNotificationTitle: 'Drillhole moved',
  RingMovedNotificationTitle: 'Ring moved',
  DrillholeEditedNotificationTitle: 'Drillhole updated',
  RingEditedNotificationTitle: 'Ring updated',
  SurveySignoffNotificationTitle: 'Survey signoff request',
  DrillholeCreatedNotificationTitle: 'Drillhole created',
  BulkDrillholesUpdateNotificationTitle: 'Drillholes edited',
  BulkDrillholesMovedNotificationTitle: 'Drillholes moved',
  BulkRingsMovedNotificationTitle: 'Rings moved',
  BulkDrillholesDeletedNotificationTitle: 'Drillholes deleted',
  BulkRingsDeletedNotificationTitle: 'Rings deleted',
  BulkProjectsDeletedNotificationTitle: 'Projects deleted',
  BulkRingsCreatedNotificationTitle: 'Rings created',
  BulkDrillholesCreatedNotificationTitle: 'Drillholes created',
  SurveyDeletedNotificationTitle: 'Survey deleted',
  SurveyDeletedNotificationDescription: 'Survey "{A}" was deleted.',
  OrganizationCreationFinishedNotificationDescription: 'Organization {A} was created with {X} members.',
  OrganizationExpirationWarningNotificationDescription: 'Organization {A} is about to expire.',
  OrganizationCreationErrorNotificationDescription: 'There was an error creating Organization {A}.',
  OrganizationIsAvailableNotificationDescription: 'Organization {A} is now available.',
  LicenseNeedsApprovalNotificationDescription: 'A license with tool code {A} needs approval.',
  LicenseWasRenewedNotificationDescription: 'A license with tool code {A} was renewed.',
  SurveySynchedNotificationDescription: 'The survey "{A}" has been synchronized on drillhole "{B}".',
  ProjectDeletedNotificationDescription: 'Project "{A}" was deleted.',
  ProjectEditedNotificationDescription: 'Project "{A}" was edited.',
  DrillholeDeletedNotificationDescription: 'Drillhole "{A}" was deleted.',
  RingDeletedNotificationDescription: 'Ring "{A}" was deleted.',
  DrillholeMovedNotificationDescription: 'The drillhole "{B}" was moved to "{A}".',
  RingMovedNotificationDescription: 'The ring "{B}" was moved to project "{A}".',
  DrillholeEditedNotificationDescription: 'The drillhole "{A}" was updated',
  RingEditedNotificationDescription: 'The ring "{A}" was updated',
  SurveySignoffNotificationDescription: 'A signoff was requested for survey "{A}".',
  DrillholeCreatedNotificationDescription: 'A drillhole with name "{B}" has been created on "{A}".',
  RingCreatedNotificationDescription: 'A ring with name "{B}" was created in project "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} drillholes were edited on "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} drillholes were moved to "{B}".',
  BulkRingsMovedNotificationDescription: '{X} rings were moved to project "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} drillholes were deleted',
  BulkRingsDeletedNotificationDescription: '{X} rings were deleted',
  BulkProjectsDeletedNotificationDescription: '{X} projects were deleted.',
  BulkRingsCreatedNotificationDescription: '{X} rings were created.',
  BulkDrillholesCreatedNotificationDescription: '{X} drillholes were created on "{B}".',
  ForgotPasswordNotificationTitle: 'Password reset email sent',
  OrganizationInvitationNotificationTitle: 'Organization invitation received',
  LicenseQRSharedNotificationTitle: 'License shared with you',
  ToolUsageReportNotificationTitle: 'Tool usage report ready',
  OrganizationCreationFinishedNotificationTitleError: 'Error creating organization',
  OrganizationIsAvailableNotificationTitleError: 'Error making organization available',
  LicenseWasRenewedNotificationTitleError: 'Error renewing license',
  RingCreatedNotificationTitleError: 'Error creating ring',
  SurveySynchedNotificationTitleError: 'Error synchronizing survey',
  ProjectDeletedNotificationTitleError: 'Error deleting project',
  ProjectEditedNotificationTitleError: 'Error editing project',
  DrillholeDeletedNotificationTitleError: 'Error deleting drillhole',
  RingDeletedNotificationTitleError: 'Error deleting ring',
  DrillholeMovedNotificationTitleError: 'Error moving drillhole',
  RingMovedNotificationTitleError: 'Error moving ring',
  DrillholeEditedNotificationTitleError: 'Error updating drillhole',
  RingEditedNotificationTitleError: 'Error updating ring',
  DrillholeCreatedNotificationTitleError: 'Error creating drillhole',
  BulkDrillholesUpdateNotificationTitleError: 'Error editing drillholes',
  BulkDrillholesMovedNotificationTitleError: 'Error moving drillholes',
  BulkRingsMovedNotificationTitleError: 'Error moving rings',
  BulkDrillholesDeletedNotificationTitleError: 'Error deleting drillholes',
  BulkRingsDeletedNotificationTitleError: 'Error deleting rings',
  BulkProjectsDeletedNotificationTitleError: 'Error deleting projects',
  BulkRingsCreatedNotificationTitleError: 'Error creating rings',
  BulkDrillholesCreatedNotificationTitleError: 'Error creating drillholes',
  SurveyDeletedNotificationTitleError: 'Error deleting survey',
  ForgotPasswordNotificationTitleError: 'Error sending password reset email',
  OrganizationInvitationNotificationTitleError: 'Error sending organization invitation',
  LicenseQRSharedNotificationTitleError: 'Error sharing license',
  ToolUsageReportNotificationTitleError: 'Error generating tool usage report',

  SurveyDeletedNotificationDescriptionError: 'There was an error deleting survey "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'There was an error creating organization {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'There was an error making organization {A} available.',
  LicenseWasRenewedNotificationDescriptionError: 'There was an error renewing the license with tool code {A}.',
  SurveySynchedNotificationDescriptionError: 'There was an error synchronizing survey "{A}" on drillhole "{B}".',
  ProjectDeletedNotificationDescriptionError: 'There was an error deleting project "{A}".',
  ProjectEditedNotificationDescriptionError: 'There was an error editing project "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'There was an error deleting drillhole "{A}".',
  RingDeletedNotificationDescriptionError: 'There was an error deleting ring "{A}".',
  DrillholeMovedNotificationDescriptionError: 'There was an error moving drillhole "{B}" to "{A}".',
  RingMovedNotificationDescriptionError: 'There was an error moving ring "{B}" to project "{A}".',
  DrillholeEditedNotificationDescriptionError: 'There was an error updating drillhole "{A}".',
  RingEditedNotificationDescriptionError: 'There was an error updating ring "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'There was an error creating drillhole "{A}" on "{B}".',
  RingCreatedNotificationDescriptionError: 'There was an error creating ring "{A}" in project "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'There was an error editing {X} drillholes on "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'There was an error moving {X} drillholes to "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'There was an error moving {X} rings to project "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'There was an error deleting {X} drillholes.',
  BulkRingsDeletedNotificationDescriptionError: 'There was an error deleting {X} rings.',
  BulkProjectsDeletedNotificationDescriptionError: 'There was an error deleting {X} projects.',
  BulkRingsCreatedNotificationDescriptionError: 'There was an error creating {X} rings.',
  BulkDrillholesCreatedNotificationDescriptionError: 'There was an error creating {X} drillholes on "{B}".',
  ForgotPasswordNotificationDescriptionError: 'There was an error sending the password reset email.',
  OrganizationInvitationNotificationDescriptionError: 'There was an error with an organization invitation. Please verify.',
  LicenseQRSharedNotificationDescriptionError: 'There was an error sharing the license.',
  ToolUsageReportNotificationDescriptionError: 'There was an error generating or sending the tool usage report.',
  SurveySynchedRingNotificationDescriptionError: 'There was an error synchronizing survey "{A}" on drillhole "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'There was an error synchronizing survey "{A}" on ring "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'There was an error synchronizing survey "{A}" in the quarantine.',
  IsRead: 'Read',
  RelatedEntityName: 'Related entity name',
  RelatedEntityType: 'Related entity type',
  RedirectEntityName: 'Redirect entity name',
  RedirectEntityType: 'Redirect entity type',
  Count: 'Count',
  Enable: 'Enable',
  SendNotificationsViaEmail: 'Send notifications via email',
  Title: 'Title',
  Description: 'Description',
  TypeHeader: 'Type',

  ForgotPasswordNotificationDescription: 'An email containing a password reset link has been sent.',
  OrganizationInvitationNotificationDescription: 'You have been invited to join an organization. Please check your email for more details.',
  LicenseQRSharedNotificationDescription: 'A license has been shared with you. Please check your email for more details.',
  ToolUsageReportNotificationDescription: 'The tool usage report was successfully generated and sent to your email.',
  Now: 'Now',
  EmptyNotificationsTextTitle: 'You’re all caught up!',
  EmptyNotificationsTextSubtitle: 'You have no new notifications',
  LastWeek: 'Last week',
  Today: 'Today',
  ThisWeek: 'This week',
  ThisMonth: 'This month',
  MarkAsRead: 'Mark as read',
  MarkAsReadAll: 'Mark as read',

  //Permissions
  //Admin
  CreatePartnerOrganization: 'Create Partner Organization',
  DeletePartnerOrganization: 'Delete Partner Organization',
  ManageDefaultRoles: 'Manage Default Roles',
  ManagePermissions: 'Manage Permissions',
  //Partners
  BlockOrganization: 'Block Organization',
  CreateOrganization: 'Create Organization',
  DeleteOrganization: 'Delete Organization',
  ManageLicenses: 'Manage Licenses',
  ManageRoleAssignment: 'Manage Role Assignments',
  //Organization
  CreateProject: 'Create Project',
  ManageGroups: 'Manage Groups',
  ManageOrganizationInfo: 'Manage Organization Info',
  ManageOrganizationRoleAssignments: 'Manage Organization Role Assignments',
  ManageQuarantine: 'Manage Quarantine',
  ManageRecycleBin: 'Manage Recycle Bin',
  ManageRoles: 'Manage Roles',
  ManageUnitSystem: 'Manage Unit System',
  ManageUnitSystems: 'Manage Unit Systems',
  ManageUsers: 'Manage Users',
  //Project
  CreateDrillhole: 'Create Drillhole',
  DeleteProject: 'Delete Project',
  ManageProjectInfo: 'Manage Project Info',
  ManageProjectRoleAssignments: 'Manage Project Role Assignments',
  ViewProjectData: 'View Project Data',
  //Ring
  CreateRing: 'Create Ring',
  DeleteRing: 'Delete Ring',
  ManageRingInfo: 'Manage Ring Info',
  ManageRingRoleAssignments: 'Manage Ring Role Assignments',
  ShareRing: 'Share Ring',
  ViewRingData: 'View Ring Data',
  CreateRingDrillhole: 'Create Ring Drillholes',
  //Drillhole
  DeleteDrillhole: 'Delete Drillhole',
  ManageDrillholeInfo: 'Manage Drillhole Info',
  ManageDrillholeRoleAssignments: 'Manage Drillhole Role Assignments',
  ViewDrillholeData: 'View Drillhole Data',
  ManageSurveys: 'Manage Surveys',
  SynchronizeSurveys: 'Synchronize Surveys',
  WelcomBackParam: 'Welcome back, {0}!',
  Change: 'Change',
  Unauthorized: 'Unauthorized',
  YouDontHaveAccessToSite: 'You dont have access to the partners center',
  LoginOutInSecondsParam: 'Login out in {0} seconds',
  CreationJobForOrganizationEnqueued: 'Creation Job for this organization has been enqueued',
  RestartCreation: 'Restart Creation',
  AssignRoleWarning:
    'You are assigning roles: {0} to {1} at level of organization. The roles will be applied to all selected entities and {1} will have permission to all information contained in {2}',
  UpdateExpiredRoleWarning:
    'The roles: {0} were previously assigned to {1} but have expired. The selected date will replace the previous expiration date, and the roles will become active again.',

  DoYouWantToContinue: 'Do you want to continue?',
  MemberAlreadyInOrganizarion: 'The user is already a member of the organization {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'You have selected this user more than once',
  ClearFilter: 'Clear filter',
  ElementsSussessfulyDeleted: 'Elements sussessfuly deleted',
  DownloadErrorsFile: 'Download errors file',
  Errors: 'Errors',
  DownloadWarningsFile: 'Download warnings file',
  Warnings: 'Warnings',
  FailDeletion: 'Deletion Failed',
  OrderBy: 'Order by',
  rowsSelected: 'row(s) selected',
  AddNew: 'Add new',
  DeleteAll: 'Delete All',
  ImportCSV: 'Import CSV',
  BulkUploadItems: 'Bulk upload items',
  Licenses: 'Licenses',
  ToolCode: 'Tool Code',
  DeviceType: 'Device Type',
  FromDate: 'From Date',
  UntilDate: 'Until Date',
  CreatedOn: 'Created On',
  CreatedBy: 'Created By',
  Unlimited: 'Unlimited',
  Coefficients: 'Coefficients',
  Continuous: 'Continuous',
  Multishot: 'Multishot',
  Zupt: 'Zupt',
  Offline: 'Offline',
  Flash: 'Flash',
  Notes: 'Notes',
  AddLicense: 'Add License',
  AddNewLicense: 'Add New License',
  PleaseEnterToolCode: 'Please enter tool code',
  LicenseCopied: 'License copied to clipboard',
  License: 'License',
  Copy: 'Copy',
  ErrorLoadingLicense: 'Error Loading License',
  ShowLicense: 'Show License',
  LicenseAlreadyExists:
    'You are trying to create a new license for {0} #{1} from {6} to {7}, but there is a license already created for {0} #{1} from {2} to {3} by {4} on {5}. Do you want to continue and create a new license anyway?',
  UnlimitedLicenseAlreadyExists:
    'There is an unlimited license already created for {0} #{1} by {2} on {3}. Do you want to continue and create a new license anyway?',
  Continue: 'Continue',
  PeriodOfValidity: 'Period Of Validity',
  CopyLicense: 'Copy License',
  CopyAll: 'Copy All',
  PleaseSelectDates: 'Please Select Dates',
  Project: 'Project',
  Customer: 'Customer',
  ExportCSV: 'Export CSV',
  Reports: 'Reports',
  Export: 'Export',
  Separator: 'Separator',
  Tab: 'Tab',
  Semicolon: 'Semicolon',
  Comma: 'Comma',
  AreYouSureYouWantToDelete: 'Are you sure you want to delete selected items?',
  AreYouSureYouWantToDeleteSelected: 'Are you sure you want to delete selected items?',
  ThereWasAProblemCreatingLicense: 'There was a problem creating the license. Please, contact an admin.',
  ExpirationDate: 'Expiration Date',
  UpdateRoleAttributes: 'Update Role Attributes',
  Update: 'Update',
  AllowedDevices: 'Allowed Devices',
  RoleExpirationDate: 'Role Expiration Date',
  PleaseEnterExpirationDate: 'Please, enter an expiration date',
  MaximumLicenseDueDate: 'Maximum License Due Date',
  PleaseEnterMaxDueDate: 'Please, enter the maximum license due date',
  MaxLicensesPeriodInDays: 'Maximum License Period In Days',
  PleaseEnterMaxLicensesPeriodInDays: 'Please, enter the maximum license period in days',
  MaxNumberOfLicensesPerMonth: 'Maximum Number Of Licenses Per Month',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Please, enter the maximum number of licenses per month',
  DeleteElements: 'Delete elements',
  DeleteItems: 'Delete elements',
  DeleteSelected: 'Delete selected',
  DeviceTypeNotAllowed: 'You are not allowed to create a license for that device',
  MaximumLicenseDueDateReached: 'You are not allowed to create licenses with a due date after {0}',
  MaxLicensesPeriodInDaysReached: 'The licenses you create must be valid for a period of {0} days at most.',
  MaxNumberOfLicensesPerMonthReached:
    'You have reached the maximum number of licenses created per month. Please, wait until next month to create a new license.',
  ApprovalPending: 'Approval Pending',
  InitializingOrganization: 'Initializing Organization. Users will be available soon',
  InvalidToolCode: 'Tool code must have exactly four digits',
  EditRoles: 'Edit roles',
  EditRolesMessage: 'Edit user roles',
  RolesWillBeRemoved: 'The following roles will be removed: {0}. ',
  RolesWillBeAssigned: 'The following roles will be assigned: {0}. ',
  ThisUserIsOrganizationMaster: 'This user has been already selected as the organization master',
  RemainingLicensesMessage: 'You have a total of {0} licenses remaining for this month',
  MaxLicenseNumberReached: 'You have reached the maximum number of licenses for this month',
  EULATitle: 'End-User License Agreement (EULA)',
  OrganizationIsExporting: 'Organization is exporting, please wait...',
  ErrorExportingOrganization: 'There was an error exporting organization {0}. Please try again.',
  ExportingOrganizationSuccess: 'The export process has started, when it finishes we will send a download link to your email address.',
  CanNotDeleteOrganizationWhileExporting:
    'The organization {0} is being exported and cannot be deleted right now. Please wait and try again in a while.',
  CheckingIfOrganizationExists: 'Checking if organization exists...',
  RestoreOrganizationConfirmDialog:
    'This organization already exists, do you want continue? All data from this organization will be ovewritten with the backup data.',
  ExportingProcessStarted: 'The exporting process has started, the download will start soon.',
  ExportOrganization: 'Export Organization',
  ImportOrganization: 'Import Organization',
  UploadOrganizationBackup: 'Upload Organization Backup',
  AddOrganizationFile: 'Click or drag organization backup file to this area to upload',
  ImportingOrganizationStarted: 'The import process has started',
  ImportingOrganizationSuccess: 'The import process has started, when it finishes we will send a notification to your email address.',
  ErrorImportingOrganization: 'There was an error importing the organization. Please try again.',
  Importing: 'Importing...',
  LastImportDate: 'This organization was last restored from a backup on ',
  ShowOrganizationLicenses: 'Show Org. Licenses',
  ShowAll: 'Show all',

  DefaultRolesTableError: 'There was an error loading default roles. Please try again.',
  GroupsTableError: 'There was an error loading groups. Please try again.',
  ErrorSavingGroupProperties: 'There was an error saving the group properties. Please try again.',
  ErrorAddingGroupMembers: 'There was an error adding the members to the group. Please try again.',
  GroupRolesTableError: 'There was an error loading group roles. Please try again.',
  LicensesTableError: 'There was an error loading the licenses. Please try again.',
  OrganizationsTableError: 'There was an error loading the organizations. Please try again.',
  ErrorAddingOrganizationMembers: 'There was an error adding the new members to the organization. Please try again.',
  ErrorRemovingOrganizationMembers: 'There was an error removing the new members from the organization. Please try again.',
  RoleListTableError: 'There was an error loading the roles. Please try again.',
  UsersTableError: 'There was an error loading the user list. Please try again.',
  ErrorAddingGroup: 'There was an error adding the group. Please try again.',
  ErrorRemovingGroup: 'There was an error removing the group. Please try again.',
  UserRolesTableError: 'There was an error loading user roles. Please try again.',
  InvitationNotSentErrorMessage: 'There was an error sending the invitation. Please try again.',
  ErrorDeletingUser: 'There was an error deleting the user. Please try again.',
  PartnerRolesTableError: 'There was an error loading partner roles. Please try again.',
  PaginationTotal: 'Showing {0} items of {1}',
  SelectOrInviteUser: 'Select or invite user',
  SelectOrInviteUsers: 'Select or invite users',
  CheckDB: 'Check database',
  ManageGlobalLicenses: 'Manage global licenses',
  ManageRoleAssignments: 'Manage role assignments',
  ShareDrillhole: 'Share drillholes',
  SignOffSurveys: 'Sign off surveys',
  ViewSurveyData: 'View survey data',
  Organizations: 'Organizations',
  SelectSelector: 'Select Selector',
  SelectOrganization: 'Select organization',
  GroupMembership: 'Group membership',
  SelectEntity: 'Select entity',
  Users: 'Users',
  AddUserToGroups: 'Add user to groups',
  SelectLanguage: 'Select language',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  Restore: 'Restore',
  RestoreBackupConfirmMessage: 'Do you want to restore this backup? Any changes made to the organization after the backup was created will be lost.',
  RestoreBackupSuccess: 'The backup restore process has started, when it finishes we will send a notification to your email address.',
  Backups: 'Backups',
  OrganizationBackups: 'Organization Backups',
  OrganizationName: 'Organization Name',
  Statistics: 'Statistics',
  Last24Hours: 'Last 24 hours',
  Last3Days: 'Last 3 days',
  Last7Days: 'Last 7 days',
  Last28Days: 'Last 28 days',
  FilterByDate: 'Filter by date',
  Projects: 'Projects',
  Surveys: 'Surveys',
  ProjectsNumber: 'No. of Projects',
  UsersNumber: 'No. of Users',
  SurveysNumber: 'No. of Surveys',
  CreationDate: 'Creation Date',
  LastUpdate: 'Last Update',
  CustomDateRange: 'Custom date range',
  OrganizationIsLocked: 'This organization is currently locked because it is being used in another process. Please wait and try again in a while.',
  SelectGroups: 'Select Groups',
  ErrorUpdatingRole: 'There was an error updating the role permissions. Please try again.',

  WorkingHours: 'Working Hours',
  PleaseEnterWorkingHours: 'Please enter working hours',

  Country: 'Country',
  PleaseSelectCountry: 'Please select a country',

  // Country names
  Afghanistan: 'Afghanistan',
  Albania: 'Albania',
  Algeria: 'Algeria',
  Andorra: 'Andorra',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antigua and Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Armenia',
  Australia: 'Australia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaijan',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrain',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbados',
  Belarus: 'Belarus',
  Belgium: 'Belgium',
  Belize: 'Belize',
  Benin: 'Benin',
  Bhutan: 'Bhutan',
  Bolivia: 'Bolivia',
  'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
  Botswana: 'Botswana',
  Brazil: 'Brazil',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgaria',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Cambodia',
  Cameroon: 'Cameroon',
  Canada: 'Canada',
  'Cape Verde': 'Cape Verde',
  'Central African Republic': 'Central African Republic',
  Chad: 'Chad',
  Chile: 'Chile',
  China: 'China',
  Colombia: 'Colombia',
  Comoros: 'Comoros',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Côte d’Ivoire',
  Croatia: 'Croatia',
  Cuba: 'Cuba',
  Cyprus: 'Cyprus',
  'Czech Republic': 'Czech Republic',
  'Democratic Republic of the Congo': 'Democratic Republic of the Congo',
  Denmark: 'Denmark',
  Djibouti: 'Djibouti',
  Dominica: 'Dominica',
  'Dominican Republic': 'Dominican Republic',
  'East Timor': 'East Timor',
  Ecuador: 'Ecuador',
  Egypt: 'Egypt',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Equatorial Guinea',
  Eritrea: 'Eritrea',
  Estonia: 'Estonia',
  Ethiopia: 'Ethiopia',
  Fiji: 'Fiji',
  Finland: 'Finland',
  France: 'France',
  Gabon: 'Gabon',
  Gambia: 'Gambia',
  Georgia: 'Georgia',
  Germany: 'Germany',
  Ghana: 'Ghana',
  Greece: 'Greece',
  Grenada: 'Grenada',
  Guatemala: 'Guatemala',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bissau',
  Guyana: 'Guyana',
  Haiti: 'Haiti',
  Honduras: 'Honduras',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  India: 'India',
  Indonesia: 'Indonesia',
  Iran: 'Iran',
  Iraq: 'Iraq',
  Ireland: 'Ireland',
  Israel: 'Israel',
  Italy: 'Italy',
  Jamaica: 'Jamaica',
  Japan: 'Japan',
  Jordan: 'Jordan',
  Kazakhstan: 'Kazakhstan',
  Kenya: 'Kenya',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kyrgyzstan',
  Laos: 'Laos',
  Latvia: 'Latvia',
  Lebanon: 'Lebanon',
  Lesotho: 'Lesotho',
  Liberia: 'Liberia',
  Libya: 'Libya',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lithuania',
  Luxembourg: 'Luxembourg',
  Madagascar: 'Madagascar',
  Malawi: 'Malawi',
  Malaysia: 'Malaysia',
  Maldives: 'Maldives',
  Mali: 'Mali',
  Malta: 'Malta',
  'Marshall Islands': 'Marshall Islands',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauritius',
  Mexico: 'Mexico',
  Micronesia: 'Micronesia',
  Moldova: 'Moldova',
  Monaco: 'Monaco',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Morocco: 'Morocco',
  Mozambique: 'Mozambique',
  Myanmar: 'Myanmar',
  Namibia: 'Namibia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Netherlands',
  'New Zealand': 'New Zealand',
  Nicaragua: 'Nicaragua',
  Niger: 'Niger',
  Nigeria: 'Nigeria',
  'North Korea': 'North Korea',
  Norway: 'Norway',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palau: 'Palau',
  Panama: 'Panama',
  'Papua New Guinea': 'Papua New Guinea',
  Paraguay: 'Paraguay',
  Peru: 'Peru',
  Philippines: 'Philippines',
  Poland: 'Poland',
  Portugal: 'Portugal',
  Qatar: 'Qatar',
  'Republic of the Congo': 'Republic of the Congo',
  'Republic of Macedonia': 'Republic of Macedonia',
  Romania: 'Romania',
  Russia: 'Russia',
  Rwanda: 'Rwanda',
  'Saint Kitts and Nevis': 'Saint Kitts and Nevis',
  'Saint Lucia': 'Saint Lucia',
  'Saint Vincent and the Grenadines': 'Saint Vincent and the Grenadines',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'Sao Tome and Principe',
  'Saudi Arabia': 'Saudi Arabia',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Sierra Leone',
  Singapore: 'Singapore',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  'Solomon Islands': 'Solomon Islands',
  Somalia: 'Somalia',
  'South Africa': 'South Africa',
  'South Korea': 'South Korea',
  'South Sudan': 'South Sudan',
  Spain: 'Spain',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudan',
  Suriname: 'Suriname',
  Swaziland: 'Swaziland',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  Syria: 'Syria',
  Tajikistan: 'Tajikistan',
  Tanzania: 'Tanzania',
  Thailand: 'Thailand',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad and Tobago',
  Tunisia: 'Tunisia',
  Turkey: 'Turkey',
  Turkmenistan: 'Turkmenistan',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ukraine',
  'United Arab Emirates': 'United Arab Emirates',
  'United Kingdom': 'United Kingdom',
  'United States of America': 'United States of America',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Uzbekistan',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietnam',
  Yemen: 'Yemen',
  Zambia: 'Zambia',
  Zimbabwe: 'Zimbabwe',

  TestOrganization: 'Test Organization',
  RemovalDate: 'Removal date',
  IsTestOrganization: 'Is a test organization',
  TestingEndDate: 'Test end date:',
  TestOrgConfirmationMessage:
    'The entity has been set up as a test organization and will be automatically deleted on the selected date. Are you sure you want to continue?',

  Show: 'Show',
  Changed: 'Changed',
  Unchanged: 'Unchanged',

  Charts: 'Charts',

  CreationChartLegend: 'Creation',
  UpdateChartLegend: 'Update',
  LicenseDetails: 'License Details',
  Logout: 'Logout',

  CrashError: 'Oops! Something went really wrong',
  SeeAllLogs: 'Please press F12 and send all logs in the Console tab when you report this incident',
  ReturnHome: 'Return Home',

  InvalidEmailWarning: 'Please select or type a valid email',
  CheckOrganizationInfoAndUsersTabs: 'Please check the organization info and users tabs. Something is wrong',

  UserHasNoOrganizationsWarning: 'This user is not part of any organization. Please add them to an organization before assigning roles.',

  UserHasNoOrganizationsGroupWarning: 'This user is not part of any organization. Please add them to an organization before adding them to groups.',

  'Customer Geologist': 'Customer Geologist',
  'Drillhole Manager': 'Drillhole Manager',
  'Field Operator': 'Field Operator',
  Geologist: 'Geologist',
  'Global License Manager': 'Global License Manager',
  'License Manager': 'License Manager',
  'Organization Coordinator': 'Organization Coordinator',
  'Organization Master': 'Organization Master',
  'Partner Administrator': 'Partner Administrator',
  'Project Manager': 'Project Manager',
  'Project Viewer': 'Project Viewer',
  'Ring Manager': 'Ring Manager',

  Partners: 'Partners',

  ActiveHours: 'Active hours',
  Active: 'Active',
  NotActive: 'Not active',
  Status: 'Status',
  Go: 'Go',
  FilterByActiveDates: 'Filter by active dates',
  ActiveDays: 'Active days',
  CanCreateUnlimitedLicense: 'Can create non expiring licenses',
  CanCreateRecurrentLicenses: 'Can create recurrent licenses',
  Recurrence: 'Recurrence',
  Activated: 'Activated',
  Deactivated: 'Deactivated',

  NeedsSignOff: 'Sign off needed',
  SelectedUserAlreadyHasTheSelectedRoles: 'The selected user already has the roles: {0}.',
  SelectedGroupAlreadyHasTheSelectedRoles: 'The selected group already has the roles: {0}.',

  FilterMode: 'Filter mode',
  AllSelected: 'All selected',
  AnyOfTheSelected: 'Any of the selected',

  Download: 'Download',

  RoleAssignmentAttributes: 'Role assignment attributes',
  LicenseManagerRoleAttributes: 'License Manager role attributes',

  'StructMaster User': 'StructMaster User',
  UseStructMaster: 'Use StructMaster',

  StructmasterLicenses: 'StructMaster licenses',
  NewStructmasterLicenseAssignment: 'New StructMaster license assignment',
  EditStructmasterLicenseAssignment: 'Edit StructMaster license assignment',
  SelectUser: 'Select user',
  UserAlreadyHasStructMasterRole: 'Error: This user already has the StrucMaster role for this organization',
  AddAnotherAssignment: 'Add another assignment',
  AddRole: 'Add role',
  SelectRole: 'Select role',
  PleaseSelectRole: 'Please select a role',
  DuplicatedRolesWarning: 'There are duplicate roles in your selection. Please ensure there are no duplicate roles.',
  RolesWillBeUpdated: 'The following roles will be updated: {0}. ',

  UserHasNoRoleWarning: 'The user must have at least one role in the organization',

  UserWillBeAddedToOrganizationBeforeAssign:
    'Warning: The user "{0}" does not belong to the organization "{1}", therefore, the user "{0}" will be added to the organization before making the assignment.',

  ManageCategories: 'Manage categories',
  ManageGeographicInformationSystems: 'Manage geographic information systems',

  Appearance: 'Appearance',
  DarkTheme: 'Dark theme',
  LightTheme: 'Light theme',
  UseSystemTheme: 'Use system theme',
  ScheduledMaintenanceText:
    'Scheduled Maintenance: The cloud platform will be undergoing scheduled maintenance on {0}. Services may be interrupted for an estimated duration of {1} hours, starting at {2}',
  MFAStatus: 'Multi-Factor Authentication Status',
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  EnableMFA: 'Enable Multi-Factor Authentication',
  DisableMFA: 'Disable Multi-Factor Authentication',

  UserLimit: 'User limit',
  PleaseEnterUserLimit: 'Please enter user limit',
  CheckLicenseInfoAndUsersTabs: 'Please check lincense info and user tabs. Something is wrong',
  LicenseInfo: 'License Info',
  AddNewStructmasterLicense: 'Add new StructMaster license',
  StructmasterLicense: 'StructMaster license',
  PleaseAddAtLeastOneUser: 'Please add at least one user',
  DuplicatedUserWarning: 'This user is already selected, please verify',
  LicenseName: 'License name',
  UserAmountExceedLimit: 'The number of users entered exceeds the selected limit, please check that the data is correct.',

  UserAlreadyIsLicenseManagerError: 'This user is already on a License Manager group. Please select a different user',
  UserAlreadyIsStructmasterUserError: 'This user already has the StructMaster role. Please select a different user',
  DefaultGroups: 'Default groups',
  LicenseManagerGroups: 'License Manager groups',
  UpdateAttributes: 'Update Attributes',
  ResetLicenseAccess: 'Reset license access',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'This user is already on a License Manager group, and there is at least one License Manager group in your selection. Please review it.',
  MoreThanOneLicenseManagerGroupSelectedError:
    'There is more than one License Manager group in your selection, and an user can only be on a single License Manager group. Please review your selection.',
  Default: 'Default',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'There is already a StructMaster license with this name, please select a different name.',
  ThereIsAlreadyAGroupWithThisName: 'There is already a group with this name, please select a different name',

  GroupLogsTableError: 'There was an error loading group audit logs. Please try again.',
  DownloadQR: 'Download QR',
  FilterByUser: 'Filter by user',

  ActiveUser: 'Active user',

  AllowAllPermissionsForThisLevel: 'Allow all permissions for this level',
  AllowAllAvailablePermissions: 'Allow all available permissions',
  AllowAllAvaliablePermissionsForThisSelector: 'Allow all avaliable permissions for this selector',

  StructmasterLicensesOnlyOneActiveUserWarning: 'Warning: There can only be one active user at a time for each StructMaster license.',

  SelectUsersToShare: 'Select users to share',
  SelectOrEnterEmailAddress: 'Select user or enter email address',
  Share: 'Share',
  NoUsersSelectedError: 'Please select at least one user or enter an email adress',
  AddEmail: 'Add Email',

  OrganizationUserLimitWarningCreation: 'Warning: You can only add a maximum of {0} users to an organization',
  OrganizationUserLimitWarningParam:
    'Warning: You can only add a maximum of {0} users to this organization and you already have a total of {1}, so you will only be able to add a total of {2}.',
  OrganizationReachedUserLimit: 'Error: This organization already has the maximum number of users allowed. Please select another organization.',
  NewGroupUserCountErrorParam:
    'Error: This organization has a maximum of {0} users with a current amount of {1} users, and you are trying to add {2} new users. Please check that the information is correct.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'The following users will be added to the organization:',

  UnsignedStructmasterLicenses: 'Unsinged StructMaster licenses',
  SaveAndSignOff: 'Save and sing off',
  SignOffStructmasterLicenseWarningTitle: 'Sign Off StructMaster License',
  SignOffStructmasterLicenseWarningMessage:
    'You are about to approve the creation of a new StructMaster license. Users will be added to the selected organization if they are not already there and the role will be assigned. Do you want to continue?',

  ShowOnlyUnsignedLicenses: 'Show only licenses pending approval',
  ClearFilters: 'Clear filters',
  ApproveLicenses: 'Approve Licenses',
  Save: 'Save',

  SoftwareVersion: 'Software version',

  AnErrorOcurred: 'An error ocurred:',
  DeleteUnsignedLicense: 'Delete unsigned license',
  DeleteUnsignedLicenseWarning: 'Are you sure you want to delete the unsigned license "{0}"?',
  SignOff: 'Sign off',
  Refuse: 'Refuse',

  ErrorCreatingLicense: 'Error creating license',
  ErrorUpdatingLicense: 'Error updating license',

  DuplicatedRoleNameErrorCreate:
    'Error creating role: A role with the name "{0}" already exists in organization "{1}". Please enter a different name.',
  DuplicatedRoleNameErrorUpdate:
    'Error updating role: A role with the name "{0}" already exists in organization "{1}". Please enter a different name.',
  DuplicatedDefaultRoleNameErrorUpdate: 'Error updating role: A default role with the name "{0}" already exists. Please enter a different name.',
  PleaseEnterAValidSearchTerm: 'Please enter a valid search term',
  TextFieldLimitError: 'The field "{0}" must not exceed {1} characters',
  InvalidToolcode: 'Please enter a valid tool code',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'License manager groups must have at least one role',
  PleaseSelectAtLeastOneDeviceType: 'Please select at least one device type',
  Language: 'Language',
  NoData: 'No Data',
  PleaseEnterCoreDiameter: 'Please enter core diameter',
  CoreDiameter: 'Core diameter',
  SmartCoreLicenseAlreadyExists:
    'You are trying to create a new license for {0} #{1} with tool diameter "{8}" from {6} to {7}, but there is a license already created for {0} #{1} with tool diameter "{8}" from {2} to {3} by {4} on {5}. Do you want to continue and create a new license anyway?',
  UnlimitedSmartCoreLicenseAlreadyExists:
    'There is an unlimited license already created for {0} #{1} with tool diameter "{8}" by {2} on {3}. Do you want to continue and create a new license anyway?',
  ToolDiameter: 'Tool diameter',
  ToolcodeTooLarge: 'The tool code is too large. The tool code must be a number between 1 and 65535',
  'License Reviewer': 'License Reviewer',
  'Client Manager': 'Client Manager',
  MeasurementCount: 'Surveys',
  ToolSerialNumber: 'Tool serial number',
  ExportCsvReport: 'Export CSV report',
  ToolType: 'Tool type',
  FirstUsedOn: 'First usage date',
  LastUsedOn: 'Last usage date',
  ErrorGeneratingReport: 'There was an error generating the report. Please try again.',
  ToolUsageReport: 'Tool usage report',
  ExportToolUsageReport: 'Export tool usage report',
  ToolUsageReportInProcess: "The tool usage report is being generated. It will be sent to your email address when it's finished.",
  ProjectName: 'Project name',
  Group: 'Group',
  SelectOrInviteWarning: 'Please select or invite',
  ManagePartnerOrganization: 'Manage partner organization',
  ManageAdminOrganization: 'Manage admin organization',
};
